var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Circles',{staticClass:"banner-design-elements",staticStyle:{"right":"-250px","top":"-200px","opacity":"0.05"},attrs:{"width":"1000px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }